// extracted by mini-css-extract-plugin
module.exports = {"container":"_0-ZK5","content":"bYLPt","title":"zNBX7","divider":"-SnPH","footer":"_0eca+"};